import { runExtractValue, runUpdatePropValue } from "../../../executor";
import useWatcher from "../../useWatcher";
import useAddEvent from "../core/useAddEvent";
import { isEqual } from "../core/util";


const defaultControl = (name, props, node) => {
    const { onCreated, onDestroy, onPropChanges } = useWatcher(props, node, [name]);
    let detachEvent;

    const getPropValue = () => runExtractValue(props, name)

    const attachEvent = () => {
        detachEvent = useAddEvent(['input', 'change'], node, (e) => {
            const value = e.target.value;
            const pValue = getPropValue();
            if (!isEqual(pValue, value)) {
                runUpdatePropValue(props, name, value);
            }
        })
    }

    onCreated(attachEvent);
    onPropChanges(() => {
        const value = getPropValue();
        if (!isEqual(node.value, value)) {
            node.value = value
        }
    })
    onDestroy(() => {
        if (typeof detachEvent === 'function') {
            detachEvent();
        }
    })
}

export default defaultControl;